/** Código retornado pela API quando não há norma técnica aplicável */
export const ADDITIONAL_TRADE_ITEM_IDENTIFICATION_NAO_POSSUI_NORMA =
  "NAO_POSSUI_NORMA_TECNICA_APLICAVEL";

const LABEL_NAO_POSSUI_NORMA = "Não possui norma técnica aplicável";

export function formatAdditionalTradeItemIdentificationTypeCode(
  code: string | undefined | null
): string {
  if (code == null || String(code).trim() === "") {
    return "";
  }
  if (code === ADDITIONAL_TRADE_ITEM_IDENTIFICATION_NAO_POSSUI_NORMA) {
    return LABEL_NAO_POSSUI_NORMA;
  }
  return String(code);
}

type Item = {
  additionalTradeItemIdentificationTypeCode?: string;
  additionalTradeItemIdentificationValue?: string;
};

function codeFromEntry(item: Item | string | undefined | null): string | undefined {
  if (item == null) {
    return undefined;
  }
  if (typeof item === "string") {
    return item;
  }
  return item.additionalTradeItemIdentificationTypeCode;
}

/** Código formatado + valor (quando existir), nessa ordem. */
function formatEntry(item: Item | string): string {
  if (typeof item === "string") {
    return formatAdditionalTradeItemIdentificationTypeCode(item);
  }
  const formattedCode = formatAdditionalTradeItemIdentificationTypeCode(
    item.additionalTradeItemIdentificationTypeCode
  );
  const rawValue = item.additionalTradeItemIdentificationValue;
  const valueTrim =
    rawValue != null && String(rawValue).trim() !== ""
      ? String(rawValue).trim()
      : "";
  if (formattedCode && valueTrim) {
    return `${formattedCode} ${valueTrim}`;
  }
  if (formattedCode) {
    return formattedCode;
  }
  if (valueTrim) {
    return valueTrim;
  }
  return "";
}

/** Aceita objetos da API ou strings (legado em que só o código era guardado). */
export function formatAdditionalTradeItemIdentificationsList(
  items: (Item | string)[] | undefined | null
): string {
  if (!Array.isArray(items) || items.length === 0) {
    return "";
  }
  const naoPossuiEntry = items.find((item) => {
    const code = codeFromEntry(item);
    return code === ADDITIONAL_TRADE_ITEM_IDENTIFICATION_NAO_POSSUI_NORMA;
  });
  const raw =
    naoPossuiEntry != null
      ? formatEntry(naoPossuiEntry)
      : items
          .map((item) => formatEntry(item))
          .filter((v) => v !== "")
          .join(", ");
  return raw.replaceAll("_", " ");
}
